// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quick-book-badge__text{font-size:1.2rem;left:50%;min-width:115px;top:50%;transform:translate(-48%,-46%) rotate(336deg)}.quick-book-badge__text:first-line{font-size:25px;line-height:22px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
